//DEV NOTES:
//It's recommended to create bundleIcons for icons that nest within Fluent components and then import them into your project.
// See full catalog of icons at https://react.fluentui.dev/?path=/docs/icons-catalog--docs.

import {
    ArrowExitFilled,
    ArrowExitRegular,
    BeakerFilled,
    BeakerRegular,
    BookmarkFilled,
    BookmarkRegular,
    CodeFilled,
    CodeRegular,
    CubeFilled,
    CubeRegular,
    DesignIdeasFilled,
    DesignIdeasRegular,
    DrawerArrowDownloadFilled,
    DrawerArrowDownloadRegular,
    FlowFilled,
    FlowRegular,
    FolderOpenFilled,
    FolderOpenRegular,
    LeafOneFilled,
    LeafOneRegular,
    LinkFilled,
    LinkRegular,
    OpenFilled,
    OpenRegular,
    OrganizationHorizontalFilled,
    OrganizationHorizontalRegular,
    PanelLeftContractFilled,
    PanelLeftContractRegular,
    PanelLeftExpandFilled,
    PanelLeftExpandRegular,
    PanelRightContractFilled,
    PanelRightContractRegular,
    PanelRightExpandFilled,
    PanelRightExpandRegular,
    PersonFilled,
    PersonRegular,
    PersonFeedbackFilled,
    PersonFeedbackRegular,
    SearchFilled,
    SearchRegular,
    SendFilled,
    SendRegular,
    ShareFilled,
    ShareRegular,
    TreeDeciduousFilled,
    TreeDeciduousRegular,
    TreeEvergreenFilled,
    TreeEvergreenRegular,
    WeatherMoonFilled,
    WeatherMoonRegular,
    WeatherSunnyFilled,
    WeatherSunnyRegular,
    DismissFilled,
    DismissRegular,
    DocumentSparkleFilled,
    DocumentSparkleRegular,
    SparkleFilled,
    SparkleRegular,
    StarFilled,
    StarRegular,
    MoreHorizontalFilled,
    MoreHorizontalRegular,
    bundleIcon,
    CopyFilled,
    CopyRegular,
    HistoryFilled,
    HistoryRegular,
    TaskListSquareLtrFilled,
    TaskListSquareLtrRegular,
    DocumentPdfFilled,
    DocumentPdfRegular,

  } from "@fluentui/react-icons";
  
    export const TaskListSquareLtr = bundleIcon(TaskListSquareLtrFilled, TaskListSquareLtrRegular);
  export const History = bundleIcon(HistoryFilled, HistoryRegular);
  export const Copy = bundleIcon(CopyFilled, CopyRegular);
  export const DocumentPdf = bundleIcon(DocumentPdfFilled, DocumentPdfRegular);
  export const Send = bundleIcon(SendFilled, SendRegular);
  export const MoreHorizontal = bundleIcon(MoreHorizontalFilled, MoreHorizontalRegular);
  export const ArrowExit = bundleIcon(ArrowExitFilled, ArrowExitRegular);
  export const Bookmark = bundleIcon(BookmarkFilled, BookmarkRegular);
  export const Sparkle = bundleIcon(SparkleFilled, SparkleRegular);
  export const Star = bundleIcon(StarFilled, StarRegular);
  export const DocumentSparkle = bundleIcon(DocumentSparkleFilled, DocumentSparkleRegular);
  export const Dismiss = bundleIcon(DismissFilled, DismissRegular);
  export const DrawerArrowDownload = bundleIcon(DrawerArrowDownloadFilled, DrawerArrowDownloadRegular);
  export const Beaker = bundleIcon(BeakerFilled, BeakerRegular);
  export const Code = bundleIcon(CodeFilled, CodeRegular);
  export const Cube = bundleIcon(CubeFilled, CubeRegular);
  export const DesignIdeas = bundleIcon(DesignIdeasFilled, DesignIdeasRegular);
  export const Flow = bundleIcon(FlowFilled, FlowRegular);
  export const FolderOpen = bundleIcon(FolderOpenFilled, FolderOpenRegular);
  export const LeafOne = bundleIcon(LeafOneFilled, LeafOneRegular);
  export const Link = bundleIcon(LinkFilled, LinkRegular);
  export const Open = bundleIcon(OpenFilled, OpenRegular);
  export const OrganizationHorizontal = bundleIcon(
    OrganizationHorizontalFilled,
    OrganizationHorizontalRegular
  );
  export const PanelLeftContract = bundleIcon(
    PanelLeftContractFilled,
    PanelLeftContractRegular
  );
  export const PanelLeftExpand = bundleIcon(
    PanelLeftExpandFilled,
    PanelLeftExpandRegular
  );
  export const PanelRightContract = bundleIcon(
    PanelRightContractFilled,
    PanelRightContractRegular
  );
  export const PanelRightExpand = bundleIcon(
    PanelRightExpandFilled,
    PanelRightExpandRegular
  );
  export const Person = bundleIcon(PersonFilled, PersonRegular);
  export const PersonFeedback = bundleIcon(
    PersonFeedbackFilled,
    PersonFeedbackRegular
  );
  export const Search = bundleIcon(SearchFilled, SearchRegular);
  export const Share = bundleIcon(ShareFilled, ShareRegular);
  export const TreeDeciduous = bundleIcon(
    TreeDeciduousFilled,
    TreeDeciduousRegular
  );
  export const TreeEvergreen = bundleIcon(
    TreeEvergreenFilled,
    TreeEvergreenRegular
  );
  export const WeatherMoon = bundleIcon(WeatherMoonFilled, WeatherMoonRegular);
  export const WeatherSunny = bundleIcon(WeatherSunnyFilled, WeatherSunnyRegular);
  
  export default {bundleIcon}
  